<!--
 * @Author: DYM
 * @Date: 2020-03-17 10:15:32
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-23 18:28:45
 * @Description: file content
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="用户新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        :validate-on-rule-change="false"
        label-position="right"
        label-width="118px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <!-- 用户基本信息 start -->
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            用户基本信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userVO.userCode"
            >
              <el-input
                v-model.trim="fd.userVO.userCode"
                class="c-form__input"
                placeholder=""
                @change="handleUserCodeChange"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户名称"
              prop="userVO.userName"
            >
              <el-input
                v-model.trim="fd.userVO.userName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="联系电话"
              prop="userVO.tel"
            >
              <el-input
                v-model.trim="fd.userVO.tel"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="是否锁定"
              prop="userVO.locked"
            >
              <el-radio-group
                v-model="fd.userVO.locked"
                class="c-form__radio-group"
              >
                <el-radio label="N">
                  非锁定
                </el-radio>
                <el-radio label="Y">
                  锁定
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="有效标志"
              prop="userVO.valid"
            >
              <el-radio-group
                v-model="fd.userVO.valid"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  有效
                </el-radio>
                <el-radio label="N">
                  无效
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="邮箱"
              prop="userVO.email"
            >
              <el-input
                v-model.trim="fd.userVO.email"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="数据来源"
              prop="userVO.sourceType"
            >
              自建
            </el-form-item>
          </el-col>

          <!-- 用户基本信息扩展字段 start -->
          <el-col
            v-for="(attrUserItem, index) in attrUserList"
            :key="'attrUser'+ index"
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              :label="attrUserItem.attrName"
              :prop="'userVO.attrs.' + attrUserItem.attrKey"
            >
              <template v-if="attrUserItem.enums">
                <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                  <el-radio-group
                    v-if="!editCapacityVo"
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                  </span>
                </template>
                <template v-else>
                  <el-select
                    v-if="!editCapacityVo"
                    v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__select"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrUserItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                  </span>
                </template>
              </template>
              <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.attrs[attrUserItem.attrKey] }}
                </span>
              </template>
              <template v-else-if="attrUserItem.attrType === 'Date'">
                <el-date-picker
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.attrs[attrUserItem.attrKey] | date('yyyy-MM-dd') }}
                </span>
              </template>
            </el-form-item>
          </el-col>
          <!-- 用户基本信息扩展字段 end -->
          <!-- 用户基本信息 end -->

          <!-- 用户登录账号信息 start -->
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            用户登录账号信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="登录账号"
              prop="userAuthVO.account"
            >
              <el-input
                v-model.trim="fd.userAuthVO.account"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="登录密码"
              prop="userAuthVO.pwd"
            >
              <el-input
                v-model.trim="fd.userAuthVO.pwd"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="有效期起"
              prop="userAuthVO.effectStartDate"
            >
              <el-date-picker
                v-model="fd.userAuthVO.effectStartDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="有效期止"
              prop="userAuthVO.effectEndDate"
            >
              <el-date-picker
                v-model="fd.userAuthVO.effectEndDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <!-- 用户登录账号信息 end -->

          <!-- 身份信息 start -->
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            用户身份信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份代码"
              prop="capacityVO.capacityCode"
            >
              <el-input
                v-model.trim="fd.capacityVO.capacityCode"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份名称"
              prop="capacityVO.capacityName"
            >
              <el-input
                v-model.trim="fd.capacityVO.capacityName"
                class="c-form__input"
                placeholder=""
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期起"
              prop="capacityVO.effectStartDate"
            >
              <el-date-picker
                v-model="fd.capacityVO.effectStartDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="身份有效期止"
              prop="capacityVO.effectEndDate"
            >
              <el-date-picker
                v-model="fd.capacityVO.effectEndDate"
                class="c-form__date"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="capacityVO.deptCode"
            >
              <hm-tree-select
                ref="dept"
                v-model="fd.capacityVO.deptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                :append-to-body="true"
                :options="deptData"
                :normalizer="normalizer"
                :clearable="false"
                placeholder="请选择所属组织"
              />
            </el-form-item>
          </el-col>

          <!-- 身份扩展字段 start -->
          <el-col
            v-for="(attrCapacityItem, index) in attrCapacityList"
            :key="'attrCapacity'+ index"
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              :label="attrCapacityItem.attrName"
              :prop="'capacityVO.attrs.' + attrCapacityItem.attrKey"
            >
              <template v-if="attrCapacityItem.enums">
                <template v-if="enums[attrCapacityItem.enums] && Object.keys(enums[attrCapacityItem.enums]).length <= 2">
                  <el-radio-group
                    v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__radio-group"
                  >
                    <el-radio
                      v-for="value in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.id"
                    >
                      {{ value.text }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-else>
                  <el-select
                    v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__select"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="(value) in enums[attrCapacityItem.enums]"
                      :key="value.id"
                      :label="value.text"
                      :value="value.id"
                    />
                  </el-select>
                </template>
              </template>
              <template v-else-if="attrCapacityItem.attrType === 'String'">
                <el-input
                  v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                  class="c-form__input"
                  placeholder=""
                />
              </template>
              <template v-else-if="attrCapacityItem.attrType === 'Date'">
                <el-date-picker
                  v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
              </template>
            </el-form-item>
          </el-col>
          <!-- 身份扩展字段 end -->
          <!-- 身份信息 end -->

          <el-col
            v-if="attrCapacityList.length%2===0"
            class="c-form__col"
            :span="12"
          />
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, getPositionList, allDeptTree, attrUser, attrCapacity } from './user.service';

export default {
  name: 'AddDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        /* 表单参数必须写入，无默认值为null，避免页面加载时由于使用了对象里不存在的参数而出现报错信息 */
        // 用户信息
        userVO: {
          locked: 'N', // 是否锁定
          sourceType: '0', // 数据来源
          tel: null, // 联系电话
          userName: null, // 用户名称
          userCode: null, // 用户编码
          valid: 'Y', // 有效标志
          attrs: {} // 扩展字段
        },
        // 用户帐号信息
        userAuthVO: {
          account: null, // 帐号
          effectEndDate: null, // 有效期止
          effectStartDate: null, // 有效期起
          pwd: null // 密码
        },
        // 用户主身份信息 ,
        capacityVO: {
          capacityName: null, // 身份名称
          capacityCode: null, // 身份代码
          deptCode: null, // 身份所属组织/部门
          effectEndDate: null, // 身份有效期止
          effectStartDate: null, // 身份有效期起
          attrs: {} // 扩展字段
        }
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        'userVO.userCode': [
          this.$validUtils.required('用户编码'),
          this.$HMValidator.maxLength('用户编码', 36)
        ],
        'userVO.userName': [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        'userVO.tel': [
          this.$validUtils.required('联系电话'),
          this.$HMValidator.maxLength('联系电话', 60)
        ],
        'userVO.email': [
          this.$HMValidator.email('邮箱'),
          this.$HMValidator.maxLength('邮箱', 90)
        ],
        'userVO.locked': [this.$validUtils.required('是否锁定')],
        'userVO.valid': [this.$validUtils.required('有效标志')],
        'userVO.idNum': [
          this.$validUtils.required('身份证件号码'),
          this.$HMValidator.IDCard_18('身份证件号码')
        ],
        'userVO.sex': [this.$validUtils.required('性别')],
        'userVO.joinTime': [
          this.$validUtils.required('入职时间'),
          this.$HMValidator.startTime(this, 'fd', 'userVO.leaveTime', ['入职时间', '离职时间'])
        ],
        'userVO.leaveTime': [
          this.$HMValidator.endTime(this, 'fd', 'userVO.joinTime', ['入职时间', '离职时间'])
        ],
        'userAuthVO.account': [
          this.$validUtils.required('登录账号'),
          this.$HMValidator.maxLength('登录账号', 75)
        ],
        'userAuthVO.pwd': [this.$validUtils.required('登录密码')],
        'userAuthVO.effectStartDate': [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'userAuthVO.effectEndDate', ['有效期起', '有效期止'])
        ],
        'userAuthVO.effectEndDate': [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'userAuthVO.effectStartDate', ['有效期起', '有效期止'])
        ],
        'capacityVO.capacityCode': [
          this.$validUtils.required('身份代码'),
          this.$HMValidator.maxLength('身份代码', 36)
        ],
        'capacityVO.capacityName': [
          this.$validUtils.required('身份名称'),
          this.$HMValidator.maxLength('身份名称', 113)
        ],
        'capacityVO.effectStartDate': [
          this.$validUtils.required('身份有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'capacityVO.effectEndDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.effectEndDate': [
          this.$validUtils.required('身份有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'capacityVO.effectStartDate', ['身份有效期起', '身份有效期止'])
        ],
        'capacityVO.deptCode': [
          this.$validUtils.required('所属组织')
        ]
      },
      /* 表单校验规则 End */

      positionList: [], // 职位列表

      deptName: null, // 所属组织名称，用于页面展示

      deptData: [], // 组织机构下拉树数据

      /* 扩展字段 Start */
      attrUserList: [], // 用户
      attrCapacityList: [] // 身份
      /* 扩展字段 End */
    };
  },
  computed: {
    // 获取枚举
    enums () {
      const baseEnums = this.$HMStoreService.getEnums();
      const apiEnumsObj = this.$store.state.apiEnums;
      const apiKey = Object.keys(apiEnumsObj);
      let apiEnums = {};
      apiKey.forEach(_key => {
        apiEnums = Object.assign({}, apiEnums, apiEnumsObj[_key]);
      });
      return Object.assign({}, baseEnums, apiEnums);
    }
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.nodeCode,
          label: node.nodeName
        };
      }
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children: node.childNodes
      };
    },
    /**
     * @description: 获取组织机构树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      allDeptTree()
        .then(rsp => {
          this.deptData = rsp.data;
        })
        .catch(err => {
          console.error('获取机构树错误！', err);
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    /**
     * @description: 获取扩展字段
     * @param {*}
     * @return {*}
     */
    getAttr () {
      // 获取用户扩展字段
      attrUser()
        .then(rsp => {
          this.attrUserList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrUserList.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.userVO.attrs, this.fdRules, 'userVO.attrs.' + attrUserItem.attrKey);
          });
        })
        .catch(err => {
          console.error('获取用户扩展字段错误！', err);
        });
      // 获取身份扩展字段
      attrCapacity()
        .then(rsp => {
          this.attrCapacityList = rsp.data.filter(item => {
            return item.show === 'Y';
          });
          this.attrCapacityList.map(attrUserItem => {
            this.attrSetToData(attrUserItem, this.fd.capacityVO.attrs, this.fdRules, 'capacityVO.attrs.' + attrUserItem.attrKey);
          });
        })
        .catch(err => {
          console.error('获取身份扩展字段错误！', err);
        });
    },
    /**
     * @description: 设置扩展字段到form表单数据、规则中
     * @param {Object} _attr 扩展字段
     * @param {Object} _formVo 表单数据对象
     * @param {Object} _formRules 校验规则对象
     * @param {String} _formRuleAttr 校验规则的属性
     * @return {*}
     */
    attrSetToData (_attr, _formVo, _formRules, _formRuleAttr) {
      this.$set(_formVo, _attr.attrKey, null);
      // 设置扩展字段校验规则
      this.$set(_formRules, _formRuleAttr, []);
      //  若扩展字段有必填标志，添加必填校验
      if (_attr.attrRequired === 'Y') {
        this.$set(_formRules, _formRuleAttr, [
          this.$validUtils.required(_attr.attrName)
        ]);
      }
      // 若扩展字段有自定义的校验规则，添加自定义的校验规则
      if (_attr.patterns) {
        const patterns = (_field, pattern) => {
          return {
            pattern: patterns,
            message: `【${_field}】校验不通过`,
            trigger: ['blur', 'change']
          };
        };
        // 向已有扩展字段校验规则数组末添加自定义校验规则
        this.$set(_formRules[_formRuleAttr], _formRules[_formRuleAttr].length,
          patterns(_attr.attrName, _attr.patterns));
      }
    },
    /**
     * @description: 获取职位列表
     * @return {*}
     */
    getPositionList () {
      getPositionList()
        .then(rsp => {
          this.positionList = rsp.data.filter(item => {
            return item.status === '使用';
          });
        })
        .catch(err => {
          console.error('获取职位列表错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 用户编码变化调用方法
     * @param {String} val， 用户编码
     * @return {*}
     */
    handleUserCodeChange (val) {
      if (val) {
        // 设置用户用户登录账号默认为用户编码
        if (!this.fd.userAuthVO.account) {
          this.fd.userAuthVO.account = val;
        }
        // 设置用户身份默认为用户编码
        if (!this.fd.capacityVO.capacityCode) {
          this.fd.capacityVO.capacityCode = val;
        }
        this.isExistInCurrent();
      }
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          userService.save(_this.fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('用户新增出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 判断当前部门下是否已经存在当前用户的基本信息和身份信息
     * @param {*}
     * @return {*} Boolean
     */
    isExistInCurrent () {
      const _this = this;
      _this.loading = true;
      userService.getDeptUserInfo(_this.fd.userVO.userCode, _this.dlParams.deptCode)
        .then(rsp => {
          const isUserInfo = rsp.data.data;
          if (isUserInfo) {
            _this.$alert('该用户信息已经存在，不能添加用户！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
                // _this.$refs.fd.resetFields();
                _this.fd.userVO.userCode = null;
                _this.fd.userAuthVO.account = null;
                _this.fd.capacityVO.capacityCode = null;
              }
            });
            _this.loading = false;
            return;
          }
          _this.numInOtherDept();
        })
        .catch(err => {
          console.error('查询出错', err);
          _this.loading = false;
          // _this.$refs.fd.resetFields();
          _this.fd.userVO.userCode = null;
          _this.fd.userAuthVO.account = null;
          _this.fd.capacityVO.capacityCode = null;
        });
    },
    /**
     * @description: 判断其他部门是否存在该用户信息
     * @param {*}
     * @return {*} 其他部门存在该用户的数量
     */
    numInOtherDept () {
      const _this = this;
      userService.userInOtherDept(_this.dlParams.deptCode, _this.fd.userVO.userCode)
        .then(rsp => {
          const num = rsp.data.data;
          if (num > 0) {
            _this.$confirm('该用户已经存在部门信息，但在本级机构下不存在身份信息，是否在本机构下新增身份信息？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).then(() => {
              _this.$emit('closeDialog', '');
              _this.$emit('addCapacityToDept', { userCode: _this.fd.userVO.userCode });
            }).catch(() => {
              // _this.$refs.fd.resetFields();
              _this.fd.userVO.userCode = null;
              _this.fd.userAuthVO.account = null;
              _this.fd.capacityVO.capacityCode = null;
            });
          }
        })
        .catch(err => {
          console.error('查询出错', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 页面初始化
     * @param {*}
     * @return {*}
     */
    init () {
      this.loading = true;
      // this.getPositionList();

      // 获取扩展字段
      this.getAttr();
      // 获取组织机构
      this.getAllDeptTree();

      /* 初始化时间起止 Start */
      this.fd.userAuthVO.effectStartDate = new Date().getTime();
      this.fd.capacityVO.effectStartDate = new Date().getTime();
      this.fd.userAuthVO.effectEndDate = new Date('9999-12-31').getTime();
      this.fd.capacityVO.effectEndDate = new Date('9999-12-31').getTime();
      /* 初始化时间起止 End */

      // 获取路由的机构代码
      this.deptName = this.dlParams.deptName;
      this.fd.capacityVO.deptCode = this.dlParams.deptCode;
    }
  },
  created () {
    this.init();
  }
};
</script>
